import { useMissionStore } from '../../../shared/store/useMissionStore';
import { useChapterStore } from '../../../shared/store/useChapterStore';
import { useMemo } from 'react';
import Button from '@/components/Button';
import {
  COMPLETE_MISSION,
  CompleteMissionMutation,
  CompleteMissionMutationVariables,
  MissionStatus,
} from '@edwin-group/cj-graphql';
import { useMutation } from '@apollo/client';
import { GetCurrentSchoolYearUseCase } from '../../../use-cases/get-current-school-year';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useToast } from '@/components/ui/use-toast';
import { ConsoleCJ } from '@/pages/Error/Console';
import { useNavigate } from 'react-router-dom';
import { trackGAEvent } from '@/lib/ga-custom-events/dispatcher';
import { usePickUpWhereYouLeftOff } from '@/pages/home/hooks/usePickUpWhereYouLeftOff';

export const MarkAsCompleted = () => {
  const mission = useMissionStore((state) => state.mission);
  const chapter = useChapterStore((state) => state.chapter);
  const chapterPage = useChapterStore((state) => state.chapterPage);
  const navigate = useNavigate();
  const { schoolContext } = useAuthentication();
  const { toast } = useToast();
  const { setLastChapterOpened } = usePickUpWhereYouLeftOff();
  const [completeMission, { loading: loadingSubmit }] = useMutation<
    CompleteMissionMutation,
    CompleteMissionMutationVariables
  >(COMPLETE_MISSION, {
    refetchQueries: 'all',
  });

  const isLastChapter = useMemo(() => {
    return mission?.chapters?.[mission?.chapters?.length - 1]?.uuid === chapter?.uuid;
  }, [mission, chapter]);

  if (!isLastChapter) return null;

  const onPressMarkAsCompleted = () => {
    completeMission({
      variables: {
        data: {
          schoolYear: GetCurrentSchoolYearUseCase.execute(),
          missionStarted: mission?.missionStartedDocumentId,
          school: schoolContext?.documentId,
          completedAt: new Date().toISOString(),
        },
      },
    })
      .then(() => {
        toast({
          title: 'Success',
          description: chapterPage?.markAsCompletedSection?.missionCompletedMsg,
        });
        trackGAEvent('mission_completed', {
          mission_name: mission?.roleModel ?? '',
          mission_document_id: mission?.documentId ?? '',
        });
        setLastChapterOpened(null);
        navigate('/missions');
      })
      .catch((error) => {
        toast({
          title: 'Error',
          description: error.message,
          variant: 'destructive',
        });
        ConsoleCJ.customError('MarkAsCompleted', error);
      });
  };

  return (
    <div className="mt-3">
      <Button
        theme="solid-primary-600"
        onClick={onPressMarkAsCompleted}
        loading={loadingSubmit}
        disabled={mission?.status === MissionStatus.Completed}>
        {mission?.status === MissionStatus.Completed
          ? chapterPage?.markAsCompletedSection?.missionCompletedBtn
          : chapterPage?.markAsCompletedSection?.markAsCompletedBtn}
      </Button>
    </div>
  );
};
